var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 9.1665H8.69342L11.6076 6.256C11.9336 5.93056 11.9336 5.40292 11.6076 5.07749C11.2816 4.75205 10.753 4.75205 10.427 5.07749L6.088 9.41082C5.76201 9.73626 5.76201 10.2639 6.088 10.5893L10.427 14.9227C10.753 15.2481 11.2816 15.2481 11.6076 14.9227C11.9336 14.5972 11.9336 14.0696 11.6076 13.7442L8.69294 10.8332H20C19.5759 15.9662 15.2684 20 10.0171 20C4.48483 20 0 15.5228 0 10C0 4.47715 4.48483 0 10.0171 0C15.2683 0 19.5757 4.03364 20 9.1665Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLogout);
export default __webpack_public_path__ + "static/media/icon-logout.53dc74a6aef54d73e18cb4e45545eb93.svg";
export { ForwardRef as ReactComponent };